import axios from 'axios'
import { BASE_PATH_PORTAL } from '../../constants'

export const regenerateCertificate = async (id: number) => {
  const response = await axios.put(`${BASE_PATH_PORTAL}/data/pārģenerēt_apliecību/${id}`, { id })
  return response.data
}
